<template>
  <el-dialog
      :visible.sync="dialogVisible"
      append-to-body
      title="会签部门选择"
      class="customer-edit"
      width="80%"
      top="5vh">
    <el-table
        ref="elTable"
        :data="departmentList">
      <el-table-column prop="departmentName" align="center" label="会签部门"/>
      <el-table-column prop="employeeName" align="center" label="会签人"/>
      <el-table-column label="操作" align="center" width="120px">
        <template slot-scope="scope">
          <el-button size="mini" type="success" @click="onSelect(scope.row)">选择</el-button>
        </template>
      </el-table-column>
    </el-table>
  </el-dialog>
</template>

<script>

  export default {
    name:"CountersignDepartmentSelect",
    components: {},
    data() {
      return {
        dialogVisible: false,
        contentLoading: false,
        submitLoading: false,
        departmentList: [
          {id: 1043,employeeName:"王同军",departmentName:"技术部"},
          {id: 1203,employeeName:"刘云峰",departmentName:"采购部"},
          {id: 1163,employeeName:"于勇",departmentName:"部件生产部"},
          {id: 1248,employeeName:"刘玉明",departmentName:"电气生产部"},
          {id: 2586,employeeName:"蔡利国",departmentName:"客户质量"},
          {id: 781,employeeName:"陈琳",departmentName:"工厂质量"},
        ],
      };
    },
    methods: {
      open() {
        this.dialogVisible = true;
      },
      onSelect(row) {
        this.$emit("select", row);
        this.dialogVisible = false;
      },
    },
  };
</script>

<style lang="scss" scoped>
</style>
